import Builder from '../../utils/redux/builder'
import { soundManager } from '../../utils/scene/sound/SoundManager'
import { image } from '../../utils/data/baseUrl'
import { getTypeBySlotType } from '../../utils/helpers/helpers'
import { isArray } from 'lodash'
import { buildSelector } from '../../utils/redux/buildSelector'
import { serviceStorage } from '../../utils/storage/service-storage'
import i18n, { languages, stores } from '../../translations'
import { showMessageSegment } from '../segments/showMessage'
import { onboardingSegment } from '../../providers/onboarding-provider'
import { stateSegment } from '../segments/state'
import { wishSegment } from '../../components/pages/wish/model/state-manager/wishSegment'
// import { guessPriceSegment } from '../../components/scenes/price';
// import { yearStatSegment } from '../../components/pages/yearStat';
import { drawingResultSegment } from '../../components/features/drawingResult'
import { interactiveShopSegment } from '../../components/pages/interactiveShop'
import { challengesSegment } from '../../components/pages/challenges'
import { productsSegment } from '../../components/features/product'
import { disposableModalsSegment } from '../../components/features/disposableModals'
import { convertToCoinsSegment } from '../../components/modals/converterToCoinsModal'
import { RARE, STANDARD } from '../../constants/shared/lootboxes/types'

const name = 'content'
//todo: написать логику группировки всех сегментов
const builder = new Builder({
  name,
  initialState: {
    ...stateSegment.initialState,
    ...showMessageSegment.initialState,
    ...onboardingSegment.initialState,
    ...challengesSegment.initialState,
    ...productsSegment.initialState,
    ...interactiveShopSegment.initialState,
    ...disposableModalsSegment.initialState,
    ...convertToCoinsSegment.initialState,
    ...drawingResultSegment.initialState,
    // ...guessPriceSegment.initialState,
    // ...yearStatSegment.initialState,
    ...wishSegment.initialState,
    showMessage: false,
    isSound: false,
    isNavigationVisible: true,
    shopItems: null,
    notFilteredShopItems: null,
    slots: null,
    viewedFriend: null,
    currentQuiz: null,
    currentQuizAnswers: [],
    quests: null,
    gameMaxScore: 0,
    levels: null,
    raffle: null,
    rafflePrizes: [],
    prizes: null,
    gamesSettings: null,
    isBath: false,
    mainSound: 'main',
    gameRating: {},
    gameRatingOld: {},
    faq: null,
    pdf: null,
    params: null,
    texts: [],
    eventRooms: [
      {
        id: null,
        system_name: 'origin',
        title: 'Комната',
        preview: image('customization/ordinary.png'),
        photo: null,
        background: image('room/originRoomBg_.png'),
      },
    ],
    lootBoxes: { standard: null, rare: null },
    activeLootBoxPrize: { id: null, type: null },
    pendingGachaReward: null,
    gameProgressData: { session: null, interval: null },
    gameDifficulty: null,
    beautyRoutine: null,
    convertData: { limit: null, converted: null, proportion: null },
    currentGameSeason: { start: null, end: null },
    previousSeasonId: null,
    activeGameSection: 'games',
    activeGameRatingName: null,
    activeTasksSection: 'daily',
    premiumAccounts: [],
    quizQuests: { groups: null, quizQuests: null, activeQuiz: null, activeWinners: null },
    showLevelPrizes: [],
    initialNyTaskActiveUid: null,
  },
  reducers: {
    ...stateSegment.reducers,
    ...showMessageSegment.reducers,
    ...challengesSegment.reducers,
    // ...guessPriceSegment.reducers,
    // ...yearStatSegment.reducers,
    ...wishSegment.reducers,
    ...interactiveShopSegment.reducers,
    ...productsSegment.reducers,
    ...disposableModalsSegment.reducers,
    ...onboardingSegment.reducers,
    setIsSound: (state) => {
      state.isSound = !state.isSound
      soundManager.muted = !state.isSound
      soundManager[`on${state.isSound ? 'Play' : 'Pause'}`](state.mainSound, {
        volume: 0.5,
        loop: true,
      })
    },
    setMainSound: (state, { payload }) => {
      soundManager.onPause(state.mainSound)
      state.mainSound = payload
      soundManager[`on${state.isSound ? 'Play' : 'Pause'}`](state.mainSound, {
        volume: 0.5,
        loop: true,
      })
    },
    setIsBath: (state, { payload }) => {
      state.isBath = payload ?? !state.isBath
    },
    setQuizAnswer: (state, { payload }) => {
      state.currentQuizAnswers.push(payload)
    },
    resetQuizAnswers: (state) => {
      state.currentQuizAnswers = []
    },
    setGameDataProgress: (state, { payload }) => {
      state.gameProgressData = payload
    },
    setActiveLootBoxPrize: (state, { payload }) => {
      state.activeLootBoxPrize = payload
    },
    setPendingGachaReward: (state, { payload }) => {
      state.pendingGachaReward = payload
    },
    clearPendingGachaReward: (state) => {
      state.pendingGachaReward = null
    },
    setActiveGameSection: (state, { payload }) => {
      state.activeGameSection = payload
    },
    setActiveGameRatingName: (state, { payload }) => {
      state.activeGameRatingName = payload
    },
    setActiveWinners(state, { payload }) {
      state.quizQuests.activeWinners = payload
    },
    setActiveQuizQuests: (state, { payload: uid }) => {
      state.quizQuests.quizQuests = state.quizQuests.quizQuests.map((item) => ({
        ...item,
        isActive: uid !== 'offAll' && item.uid === uid && !item.isActive,
      }))
    },
    setActiveQuizQuest: (state, { payload: quest }) => {
      state.quizQuests.activeQuiz = quest
    },
    setActiveTasksSection: (state, { payload }) => {
      state.activeTasksSection = payload
    },
    setShowLevelPrizes: (state, { payload: { prizeData, action } }) => {
      ;({
        removeOne: ({ id }) => state.showLevelPrizes.filter(({ id: prizeId }) => prizeId !== id),
      })[action]?.(prizeData)
    },
    setInitialNyTaskActiveUid: (state, { payload: uid }) => {
      state.initialNyTaskActiveUid = uid
    },
  },
})

builder
  .addMatcher(
    () => true,
    (state, { payload = {} }) => {
      if (!payload?.hasOwnProperty?.('profile')) return

      const levelsPrizes = state?.prizes?.levelsPrizes

      if (!isArray(levelsPrizes)) return

      const { profile } = payload

      const modalsData = serviceStorage.get('modalsData') ?? {}

      const accountMode = { true: 'premium', false: 'standard' }[
        Boolean(profile?.premiumElapsedTime)
      ]

      const newShowLevelPrizes = levelsPrizes?.filter((prize) => {
        const { isPremium, required_score, id } = prize

        if (!{ premium: isPremium, standard: !isPremium }[accountMode]) return

        return (
          profile?.score >= required_score &&
          !modalsData[`passedLevelModal${required_score}`] &&
          !state.showLevelPrizes.some(({ id: prizeId }) => prizeId === id)
        )
      })

      state.showLevelPrizes = [...state.showLevelPrizes, ...newShowLevelPrizes].sort(
        (a, b) => a.required_score - b.required_score,
      )
    },
  )
  .addExtraReducer({
    // ...guessPriceSegment.extraReducers,
    ...productsSegment.extraReducers,
    'requests/game/get-index/fulfilled'(state, { payload }) {
      payload.eventRooms.forEach((eventRoom) => state.eventRooms.push(eventRoom))
      state.faq = payload.faq
      state.levels = payload.levels
      state.raffle = payload.raffle
      state.rafflePrizes = payload.rafflePrizes
      state.prizes = {
        ...state.prizes,
        ratingPrizes: payload.ratingPrizes,
        levelsPrizes: payload.levelPrizes,
        weekRatingPrizes: payload?.weekRatingPrizes,
      }
    },
    'requests/game/get-game-rating/fulfilled'(state, { payload, meta }) {
      // разграничение между старым и новым рейтингом, запросы осуществляются в 2х местах
      // getGameRating и getOldGameRating
      if (meta.arg.updatedAt) {
        state.gameRatingOld[meta.arg.type] = payload.rating
      } else {
        state.gameRating[meta.arg.type] = payload.rating
        if (payload.season) {
          state.currentGameSeason = { start: payload.season.start_at, end: payload.season.end_at }
        }
        if (payload.previous_season_id) {
          state.previousSeasonId = payload.previous_season_id
        }
      }
    },
    'requests/game/get-user-game-rating/fulfilled'(state, { payload, meta }) {
      if (payload?.rating) {
        const {
          arg: { type, updatedAt },
        } = meta
        // разграничение между старым и новым рейтингом, запросы осуществляются в 2х местах
        // getGameRating и getOldGameRating
        if (updatedAt) {
          state.gameRatingOld[`user${type}`] = payload.rating
        } else {
          state.gameRating[`user${type}`] = payload.rating
        }
      }
    },
    'requests/shop/shop-items/fulfilled'(state, action) {
      const { payload } = action
      if (!payload) return

      const { slots, shopItems } = payload

      state.notFilteredShopItems = shopItems
      state.slots = slots
      state.shopItems = slots.reduce(
        (acc, slot) => {
          const field = getTypeBySlotType(slot.type)
          const sortedItems = shopItems.filter(({ slot: slotId }) => slotId === slot.system_name)
          return {
            ...acc,
            [field]: { ...acc[field], [slot.system_name]: { ...slot, array: sortedItems } },
          }
        },
        { room: {}, character: {} },
      )
    },
    'requests/prizes/get/fulfilled'(state, { payload: { prizes } = {} }) {
      state.prizes = { ...state.prizes, buyPrizes: prizes ?? [] }
    },
    'requests/user/get-friend/fulfilled'(state, { payload }) {
      if (payload?.user) state.viewedFriend = payload.user
    },
    'requests/user/get-wish-user-data/fulfilled'(state, { payload }) {
      if (payload?.user) state.viewedFriend = payload.user
    },
    'requests/user/get-user-data/fulfilled'(state, { payload }) {
      if (payload?.user) state.viewedFriend = payload.user
    },
    'requests/user/set-like/fulfilled'(state, { payload }) {
      if (payload?.user) state.viewedFriend = payload.user
    },
    'requests/user/set-dislike/fulfilled'(state, { payload }) {
      if (payload?.user) state.viewedFriend = payload.user
    },
    'requests/game/get-current-quiz/fulfilled'(state, { payload }) {
      const quiz = payload?.quiz
      const nextQuiz = payload?.nextQuiz

      state.currentQuiz = !quiz || quiz?.isCompleted ? nextQuiz ?? quiz : quiz
    },
    'requests/game/buy-quiz/fulfilled'(state, { payload }) {
      const quiz = payload?.quiz
      const nextQuiz = payload?.nextQuiz
      state.currentQuiz = quiz?.isCompleted ? nextQuiz : quiz
    },
    'requests/game/get-game-settings/fulfilled'(state, { payload }) {
      if (!payload?.games) return
      payload.games.sort((a, b) => (a.name === 'Memories' ? -1 : b.name === 'Memories' ? 1 : 0))
      state.gamesSettings = payload.games
    },
    'requests/params/index/fulfilled'(state, { payload }) {
      const lang = i18n.language
      const store = payload?.store
      const params = payload?.params ?? {}
      state.params = params
      const {
        rules,
        rules_kz,
        rules_en_ae,
        rules_en_qa,
        rules_en_sa,
        rules_ar_ae,
        rules_ar_qa,
        rules_ar_sa,
      } = params

      switch (store) {
        case stores.kz:
          switch (lang) {
            case languages.kz:
              state.pdf = rules_kz?.pdf
              break
            default:
              state.pdf = rules?.pdf
          }
          break
        case stores.ae:
          switch (lang) {
            case languages.en:
              state.pdf = rules_en_ae?.pdf
              break
            case languages.ar:
              state.pdf = rules_ar_ae?.pdf
              break
            default:
              state.pdf = rules?.pdf
          }
          break
        case stores.qa:
          switch (lang) {
            case languages.ar:
              state.pdf = rules_ar_qa?.pdf
              break
            default:
              state.pdf = rules_en_qa?.pdf
          }
          break
        case stores.sa:
          switch (lang) {
            case languages.ar:
              state.pdf = rules_ar_sa?.pdf
              break
            default:
              state.pdf = rules_en_sa?.pdf
          }
          break
        default:
          state.pdf = rules?.pdf
      }
    },
    'requests/game/start/fulfilled'(state, { payload }) {
      state.gameMaxScore = payload?.log?.max_score
      state.gameDifficulty = payload?.log?.difficulty
    },
    'requests/gacha/list/fulfilled'(state, { payload }) {
      state.convertData = {
        limit: payload?.convertLimit,
        converted: payload?.convertedToday,
        proportion: payload?.convertCost,
      }

      state.convertDataToCoins = {
        convertBonusesCost: payload?.convertBonusesCost,
      }

      const rare = payload?.items?.find((item) => item.event)
      const standard = payload?.items?.find((item) => !item.event)
      state.lootBoxes = { [STANDARD]: standard, [RARE]: rare }
      state.premiumAccounts = payload?.list
    },
    'requests/get-beauty-routine/fulfilled'(state, { payload }) {
      if (payload?.list) state.beautyRoutine = payload.list[0]
    },
    'requests/get-quiz-quests/fulfilled'(state, { payload }) {
      if (!payload) return
      // NOTE: иногда стреляет ошибка в кибану, что payload = undefined
      const { groups, quizQuests } = payload || {}

      const formattedQuizQuests = groups?.map((group) => {
        const uid = group.uid
        const list = quizQuests?.filter((quiz) => quiz.groupId === group.id)
        const now = Math.floor(Date.now() / 1000)
        const isCurrentWeek = now >= group.start_at && now <= group.end_at
        return { ...group, uid: group.id, list, isCurrentWeek, isActive: false, category: uid }
      })

      state.quizQuests = { groups, quizQuests: formattedQuizQuests }
    },
    'requests/submit-quiz-quest/fulfilled'(
      state,
      {
        payload: {
          result: { correct },
          nextQuest,
        },
      },
    ) {
      state.quizQuests.quizQuests = state.quizQuests.quizQuests.map((week) => {
        const updatedWeekArray = week.list.map((item) => {
          if (nextQuest?.id === item?.id) return nextQuest

          return {
            ...item,
            isCompleted: item?.id === state.quizQuests.activeQuiz?.id || item?.isCompleted,
            correctAnswersCount:
              item?.id === state.quizQuests.activeQuiz?.id ? correct : item?.correctAnswersCount,
          }
        })

        return { ...week, list: updatedWeekArray }
      })
    },
  })

// const { matchers: yearStatMatchers } = yearStatSegment;
const { matchers: drawingResultMatchers } = drawingResultSegment
const { matchers: challengesMatchers } = challengesSegment
const { matchers: disposableModalsMatchers } = disposableModalsSegment
const { matchers: wishSegmentMatchers } = wishSegment
const { matchers: convertToCoinsMatchers } = convertToCoinsSegment
;[
  /*yearStatMatchers */ convertToCoinsMatchers,
  wishSegmentMatchers,
  challengesMatchers,
  disposableModalsMatchers,
  drawingResultMatchers,
]
  .flat()
  .forEach((matcher) => builder.addMatcher(...matcher))

builder
  .createSelector('appState', buildSelector.bind({ name, fields: ['state'] }))
  .createSelector('previousStates', buildSelector.bind({ name, fields: ['previousStates'] }))
  .createSelector('showMessage', buildSelector.bind({ name, fields: ['showMessage'] }))
  .createSelector('guessPrice', buildSelector.bind({ name, fields: ['guessPrice'] }))
  .createSelector('challenges', buildSelector.bind({ name, fields: ['challenges'] }))
  .createSelector('products', buildSelector.bind({ name, fields: ['products'] }))
  .createSelector('challenges', buildSelector.bind({ name, fields: ['challenges'] }))
  .createSelector('guessPrice', buildSelector.bind({ name, fields: ['guessPrice'] }))
  .createSelector('wishes', buildSelector.bind({ name, fields: ['wishes'] }))
  .createSelector('yearStat', buildSelector.bind({ name, fields: ['yearStat'] }))
  .createSelector('disposableModals', buildSelector.bind({ name, fields: ['disposableModals'] }))
  .createSelector('interactiveShop', buildSelector.bind({ name, fields: ['interactiveShop'] }))
  .createSelector('drawing', buildSelector.bind({ name, fields: ['drawing'] }))
  .createSelector('onboarding', buildSelector.bind({ name, fields: ['onboarding'] }))
  .createSelector('gamesSettings', buildSelector.bind({ name, fields: ['gamesSettings'] }))
  .createSelector('params', buildSelector.bind({ name, fields: ['params'] }))
  .createSelector(
    'convertToCoinsData',
    buildSelector.bind({ name, fields: ['convertToCoinsData'] }),
  )

const content = builder.create().export()

export const {
  useContent,
  useChallenges,
  useWishes,
  useYearStat,
  useAppState,
  useProducts,
  useGuessPrice,
  useGamesSettings,
  useShowMessage,
  usePreviousStates,
  useDisposableModals,
  useInteractiveShop,
  useDrawing,
  useOnboarding,
  useParams,
  useConvertToCoinsData,
} = content.selectors

export const { requestState, requestPreviousState, setShowMessage, setInitialNyTaskActiveUid } =
  content.actions
export default content
